// exportExcel.js
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import moment from "moment";

export async function handleExportExcel(selectedData) {



  if (selectedData.length === 0) {
    alert("ไม่พบข้อมูลที่ตรงกับที่เลือก");
    return;
  }

  const response = await fetch("/DocumentsReceiving_new.xlsx");
  const arrayBuffer = await response.arrayBuffer();

  const workbook = new ExcelJS.Workbook();
  await workbook.xlsx.load(arrayBuffer);

  const worksheet = workbook.worksheets[0];

  const headerRowNumber = 6;
  const headerRow = worksheet.getRow(headerRowNumber);

  // map header → column index
  const headerMap = {};
  headerRow.eachCell((cell, colNumber) => {
    if (cell.value) {
      headerMap[cell.value.toString().trim()] = colNumber;
    }
  });

  let startRow = headerRowNumber + 1;
  while (worksheet.getRow(startRow).getCell(1).value) {
    worksheet.spliceRows(startRow, 1);
  }
 console.log(selectedData)

 const totalWeight = (selectedData.items || []).reduce(
  (sum, item) => sum + (item.weight || 0),
  0
);
console.log(headerMap)
  // เติมข้อมูลใหม่
    const newRow = [];
    newRow[headerMap["No./ลำดับ"]] =  1;
    newRow[headerMap["รหัสเกษตรกร / ID Famer"]] = selectedData.customer.name;
    newRow[headerMap["จำนวนรับเข้า/กก."]] = totalWeight.toLocaleString();
    newRow[headerMap["ยอดรวม"]] = totalWeight.toLocaleString();
    worksheet.insertRow(startRow + 0, newRow);

  // อัปเดตวันที่ในแถว 2
  worksheet.getCell("D4").value = selectedData.customer.name;
  worksheet.getCell("I3").value = `${moment().format("DD/MM/YYYY")}`;
  worksheet.getCell("I1").value = selectedData.billNumber  ;



  // ดาวน์โหลดไฟล์ใหม่
  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), "ReceivingForm.xlsx");
}
